const packages = [
  {
    icon: 'ri-android-line',
    name: '91浏览器 安卓版',
    tag: '稳定直装',
    version: 'v8.6.2',
    size: '42MB',
    system: 'Android 7.0+',
    desc: '主流机型适配，APK 直接安装，装完即可使用，适合日常浏览与播放。',
    featured: false,
  },
  {
    icon: 'ri-flashlight-line',
    name: '91浏览器 最新版',
    tag: '推荐升级',
    version: 'v8.6.2',
    size: '42MB',
    system: 'Android 7.0+',
    desc: '内含最新内核与卡顿修复，老用户升级后浏览与看片体验更顺滑。',
    featured: true,
  },
  {
    icon: 'ri-file-zip-line',
    name: '91浏览器 安装包',
    tag: '离线可用',
    version: 'v8.6.2',
    size: '42MB',
    system: 'Android 7.0+',
    desc: '独立安装文件，网络不稳也能先存后装，方便分享给身边的朋友。',
    featured: false,
  },
];

export default function PackagePicker() {
  return (
    <section id="versions" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="max-w-2xl reveal reveal-1">
          <span className="text-xs md:text-sm font-medium text-accent-700 tracking-wide">
            版本速览
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            三条下载路径，对应三种需求
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            不确定该下哪一个？先说清用途，再挑版本。三个入口的安装包内容一致，差别只在安装方式与更新节奏上。
          </p>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {packages.map((pkg, idx) => (
            <article
              key={pkg.name}
              className={`reveal reveal-${idx + 1} flex flex-col rounded-lg border p-6 md:p-7 transition-colors ${
                pkg.featured
                  ? 'bg-background-50 border-primary-300'
                  : 'bg-background-50 border-background-200 hover:border-background-300'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${pkg.icon} text-2xl`}></i>
                </span>
                <span
                  className={`text-xs px-3 py-1 rounded-full ${
                    pkg.featured
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  {pkg.tag}
                </span>
              </div>

              <h3 className="mt-5 font-heading font-bold text-lg md:text-xl text-foreground-950">
                {pkg.name}
              </h3>
              <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">{pkg.desc}</p>

              <dl className="mt-6 grid grid-cols-3 gap-2 text-center">
                <div className="rounded-md bg-background-100 py-2.5">
                  <dt className="text-[11px] text-foreground-500">版本</dt>
                  <dd className="text-sm font-medium text-foreground-900 mt-0.5">{pkg.version}</dd>
                </div>
                <div className="rounded-md bg-background-100 py-2.5">
                  <dt className="text-[11px] text-foreground-500">大小</dt>
                  <dd className="text-sm font-medium text-foreground-900 mt-0.5">{pkg.size}</dd>
                </div>
                <div className="rounded-md bg-background-100 py-2.5">
                  <dt className="text-[11px] text-foreground-500">系统</dt>
                  <dd className="text-sm font-medium text-foreground-900 mt-0.5">7.0+</dd>
                </div>
              </dl>

              <a
                href="#download"
                className={`mt-6 inline-flex items-center justify-center gap-2 font-medium px-5 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  pkg.featured
                    ? 'bg-primary-500 hover:bg-primary-600 text-background-50'
                    : 'bg-secondary-100 hover:bg-secondary-200 text-foreground-900'
                }`}
              >
                <i className="ri-download-2-line text-lg"></i>
                {pkg.featured ? '立即下载最新版' : '下载此版本'}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}